import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import config from "@/lib/config";
export default function absoluteURL(_ref) {
  var url = _ref.url,
      adultMode = _ref.adultMode;

  //もし相対アドレスなら絶対アドレスに変える
  if (/^https?:\/\//.test(url)) {
    return url;
  } else {
    var host = adultMode ? config.host.adult : config.host.vod;
    return [host].concat(_toConsumableArray(url.split("/"))).join("/");
  }
}